<template>
  <div class="top">
    <div class="big_title">大事记</div>
    <div class="swiper-box" v-if="picList.length > 0">
      <swiper
        :slidesPerView="4"
        :spaceBetween="24"
        :modules="modules"
        :autoplay="{
          delay: 2500,
          disableOnInteraction: false,
        }"
        :navigation="true"
        class="mySwiper2"
      >
        <swiper-slide
          class="swiper_box"
          v-for="(item, index) of picList"
          :key="index"
        >
          <div class="title" :title="item.title">{{ item.title }}</div>
          <div class="downLoad" @click="downLoadFn(item.filePreviewUrl)">
            下载<el-icon class="icon"><Download /></el-icon>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="swiper-box" v-else>
      <div class="no_box">
        <img src="@/assets/text/nopicDe.png" alt="" />
        <div class="default_text">暂无数据</div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import api from "@/api/api";
import { Download } from "@element-plus/icons-vue";
import { Swiper, SwiperSlide } from "swiper/swiper-vue.mjs";
// 这是分页器和对应方法，swiper好像在6的时候就已经分离了分页器和一些其他工具
import { Autoplay, Navigation, Pagination, A11y } from "swiper/modules";
// 引入swiper样式，对应css 如果使用less或者css只需要把scss改为对应的即可
import "swiper/swiper.min.css";
import "swiper/modules/navigation.css";
import "swiper/modules/pagination.css";
import "swiper/modules/scrollbar.css";
const modules = [Autoplay, Pagination, Navigation, A11y];
let picList = ref([]);

const getList = async () => {
  let res = await api.getDownloadList({ resourceId: 88 });
  if (res.code === "0") {
    picList.value = res.res.data;
  }
};
getList();
const downLoadFn = (file) => {
  const filePath = file; // 替换为实际的文件路径
  const link = document.createElement("a");
  link.href = filePath;
  link.download = filePath.split("/").pop();
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
</script>
<style lang="less" scoped>
:deep(.swiper-button-next) {
  transform: translate(44px, 0);
}
:deep(.swiper-button-prev) {
  transform: translate(-44px, 0);
}
.swiper-box {
  position: relative;
  .mySwiper2 {
    position: unset;
    height: 215px;
    padding: 23px;
    box-sizing: border-box;
    .swiper_box {
      position: unset;
      height: 169px;
      width: 321px;
      height: 169px;
      background: #ffffff;
      box-shadow: 0px 0px 23px 0px rgba(21, 89, 134, 0.2);
      border-radius: 12px;
      padding: 28px 41px;
      box-sizing: border-box;
      .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 1.4vw;
        color: #000000;
        line-height: 40px;
        text-shadow: 0px 0px 23px rgba(21, 89, 134, 0.2);
        text-align: left;
        font-style: normal;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
      }
      .downLoad {
        cursor: pointer;
        margin-top: 23px;
        width: 6.98vw;
        height: 38px;
        background: #006ab1;
        box-shadow: 0px 0px 23px 0px rgba(21, 89, 134, 0.2);
        border-radius: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 0.94vw;
        color: #ffffff;
        text-shadow: 0px 0px 23px rgba(21, 89, 134, 0.2);
        .icon {
          margin-left: 14px;
        }
      }
    }
  }
  .no_box {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .default_text {
      margin-top: 21px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #317eb2;
      line-height: 22px;
    }
    img {
      width: 291px;
      height: 209px;
    }
  }
}
.big_title {
  height: 5.27vh;
  font-weight: 600;
  font-size: 48px;
  line-height: 5.27vh;
  text-align: left;
  font-style: normal;
  color: #006ab1;
  margin-bottom: 3.38vh;
  font-family: PingFangSC, PingFang SC;
}
</style>